import * as service from './base';

const base_endpoint = `/api/practices/`;

export async function all() {
    const url = base_endpoint;
    return await service.get(url);
}

export async function userPractices(userId) {
    const url = `/users/${userId}/practices`
    return await service.get(url);
}

export async function get(id) {
    const url = `${base_endpoint}${id}`
    return await service.get(url);
}

export async function getWithFilter(filter) {
    const url = `${base_endpoint}?filter=${filter}`
    return await service.get(url);
}

export async function getWithFilterWithId(id, filter) {
    const url = `${base_endpoint}${id}?filter=${filter}`
    return await service.get(url);
}

export async function getPages(id) {
    const url = `${base_endpoint}${id}/pages`
    return await service.get(url);
}

export async function postPages(id, data) {
    const url = `${base_endpoint}${id}/pages`
    return await service.post(url, data);
}

export async function post(data) {
    const url = base_endpoint;
    await service.post(url, data)
}

export async function patch(id, data) {
    const url = `${base_endpoint}${id}`
    await service.patch(url, data)
}

export async function put(id, data) {
    const url = `${base_endpoint}${id}`
    await service.put(url, data)
}

export async function del(id) {
    const url = `${base_endpoint}${id}`
    await service.del(url)
}